export default "__VITE_ASSET__D2_eLxwl__$_?react__"